import { Link } from 'react-router-dom';

export default function ComingSoon() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-background-50 text-foreground-900 px-4 py-20">
      <div className="w-full max-w-md text-center space-y-7">
        {/* Icon */}
        <div className="w-16 h-16 mx-auto rounded-full bg-accent-100/70 flex items-center justify-center">
          <i className="ri-seedling-line text-2xl text-accent-600" />
        </div>

        {/* Brand + Title */}
        <div className="space-y-2">
          <p className="text-xs tracking-[0.25em] uppercase text-foreground-400">
            AUM1001 Matrix
          </p>
          <h1
            className="text-3xl md:text-4xl text-foreground-900"
            style={{ fontFamily: 'var(--font-heading)' }}
          >
            Coming Soon
          </h1>
          <p className="text-sm text-foreground-500">正在建構中</p>
        </div>

        {/* English line */}
        <p className="text-sm text-foreground-500 leading-relaxed">
          This part of the Life Tree is still growing.
        </p>

        {/* Back home */}
        <Link
          to="/"
          className="whitespace-nowrap inline-flex items-center gap-2 px-6 py-3 rounded-md bg-primary-500 text-background-50 text-sm hover:bg-primary-600 transition-colors cursor-pointer"
        >
          <i className="ri-arrow-left-line" />
          返回首頁
        </Link>

        {/* Domain */}
        <p className="text-xs text-foreground-400">aum1001matrix.org</p>
      </div>
    </div>
  );
}